/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaToggleButton/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaToggleButton({
  children,
  viewPath = "/DesignSystem/TysiaToggle/TysiaToggleButton",
  marginTop = 0,
  marginLeft = 0,
  marginBottom = 0,
  marginRight = 0,
  selected,
  hovered
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaToggleButton.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Lr5tb': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--ml-2-Z1Lr5tb': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mb-3-Z1Lr5tb': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mr-4-Z1Lr5tb': typeof marginRight === 'number' ? `${marginRight}px` : marginRight}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="TysiaToggleButton.Horizontal:1"
  data-view-path={viewPath}
 style={{'--bc-5-Z1Lr5tb': selected ? "#3F9142" : dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="TysiaToggleButton.Vertical"
  data-view-path={viewPath}
 style={{'--bc-5-Z1Lr5tb': selected ? dtColorsWhite : hovered ? "rgba(255,255,255,0.7)" : dtColorsNeutral600,'--tx-6-Z1Lr5tb': selected ? "5px" : "-5px"}}
 className={`views-block ${styles.Vertical}`}
/>
</div>
</div>
{children}
</React.Fragment>)
}